'use client';

import type { FC } from 'react';
import { renderToString } from 'react-dom/server';
import { ScContainer, ScStaticPage } from '@/styles/common';
import { DateLastUpdateStatic } from './DateLastUpdateStatic';
import type { StaticPageProps } from './types';

export const generatePrivacyPolicyContent = (
  mainText: string,
  tableHtml?: string
) =>
  tableHtml
    ? mainText.replace(
        /\{\{table\}\}/g,
        tableHtml
          ? renderToString(
              <div
                className="horizontal-scroll"
                dangerouslySetInnerHTML={{
                  __html: tableHtml,
                }}
              />
            )
          : ''
      )
    : mainText;

export const StaticPage: FC<StaticPageProps> = ({
  locale,
  title,
  mainText,
  date,
  version,
  additionalSectionComponent,
  tableHtml,
}) => (
  <ScStaticPage>
    <ScContainer>
      <h1 className={`h1 ${locale}`}>{title}</h1>

      {date && (
        <DateLastUpdateStatic
          effectiveFrom={date.effectiveFrom}
          lastUpdated={date.lastUpdated}
          version={version}
        />
      )}

      <div
        className="static-main"
        dangerouslySetInnerHTML={{
          __html: generatePrivacyPolicyContent(mainText, tableHtml),
        }}
      />

      {additionalSectionComponent && additionalSectionComponent}
    </ScContainer>
  </ScStaticPage>
);
